import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import ResourceFormProxy from "classes/ResourceFormProxy";
import {create, Types as ResourceTypes} from "api/resources";
import ReceiptItemModal from 'pages/Receipt/ReceiptItemModal'
import {RetailerItemFormModes} from "pages/Rewards/utils";
import {clone, isNoU} from "utils/DBUtils";
import * as ServiceApi from "api/services";
import {NumericInput, TextInput} from "../BasicFormFields";
import {Button} from "semantic-ui-react";
import {requestRetailersAction, setStoreAccountAction, requestNgcEndpointListAction} from "pages/Rewards/actions";
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/observable/of';

class CampaignEscrowWidget extends React.Component {

    constructor(props) {
        super(props);

        let step = this.props.formProxy.parentCurrentResource;
        let totalStock = step.availableItemStock + step.unavailableItemStock;

        this.state = {
            escrow: this.props.formProxy.parentCurrentResource.escrow || null,
            retailerItem: this.props.formProxy.parentCurrentResource.retailerItem || null,
            modifyingStock: false,
            totalItems: 0,
            budget: 0,
            totalStock: totalStock,
            newRetailerItem: {
                level: "NEW",
                ngcApiId: undefined,
                ngcDeliveryType: "api",
                retailerId: null,
                points: 0,
                price: null,
                cost: null,
                title: null,
                imageId: "",
                resourceId: {
                    type: ResourceTypes.RetailerItem,
                    id: ""
                }
            },
            requestedStoreInfo: false
        };
    }

    componentDidMount() {
        if (!this.state.requestedStoreInfo) {
            this.props.setStoreAccount();
            this.props.getRetailers();
            this.props.getNgcList();

            this.setState({
                requestedStoreInfo: true
            });
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.imageId !== this.props.imageId) {
            let item = clone(this.state.newRetailerItem);
            item.imageId = newProps.imageId;
            this.setState({
                newRetailerItem: item
            });
        }
    }

    onCreateBudgetClicked = () => {
        this.setState({
            creatingBudget: true
        });

        create(ResourceTypes.CampaignStoreEscrow, {
            // breakId,
            // stepId,
            budget: this.state.budget
        }, [
            this.props.formProxy.currentBaseResource.resourceId,
            this.props.formProxy.parentCurrentResource.resourceId
        ]).catch((error) => Observable.of(error.response))
            .subscribe((response) => {
                if (response.errorCode) {
                    this.setState({
                        stocking: false,
                        error: response.errorCode
                    });
                    return;
                }
                this.setState({
                    escrow: response.response.object,
                    creatingBudget: false
                })
            });
    };

    onStockEscrowButtonClicked = () => {
        this.setState({
            modifyingStock: true
        });
    };

    createRetailerItem = () => {
        this.setState({
            creatingRetailerItem: true
        });

        create(
            ResourceTypes.CampaignRetailerItem,
            {
                ...this.state.newRetailerItem,
                lang: this.props.formProxy.currentBaseResource.lang,
                breakId: this.props.formProxy.currentBaseResource.id,
                stepId: this.props.formProxy.parentCurrentResource.id
            },
            []
        ).catch((error) => Observable.of(error.response))
            .subscribe((response) => {
                if (response.errorCode) {
                    this.setState({
                        stocking: false,
                        error: response.errorCode
                    });
                    return;
                }
                this.setState({
                    retailerItem: response.response.object,
                    creatingRetailerItem: false
                });
            });
    };

    addStock = () => {
        this.setState({
            stocking: true
        });

        ServiceApi.performAction(
            ResourceTypes.StoreStock,
            ServiceApi.Actions.AddStock,
            {
                lang: this.props.formProxy.currentBaseResource.lang,
                escrowId: this.state.escrow.id,
                retailerItemId: this.state.retailerItem.id,
                totalItems: this.state.totalItems
            }
        ).catch((error) => Observable.of(error.response))
            .subscribe((response) => {
                if (response.errorCode) {
                    this.setState({
                        stocking: false,
                        error: response.errorCode
                    });
                    return;
                }

                this.setState({
                    stocking: false,
                    totalStock: this.state.totalItems
                })
            });
    };

    onValueChange = (errors, [field], value) => {
        let item = clone(this.state.newRetailerItem);
        item[field] = value;
        this.setState({
            newRetailerItem: item
        });
    };

    onClose = () => {
        this.setState({
            modifyingStock: false
        });
    };

    onTotalItemsChanged = (value) => {
        this.setState({
            totalItems: value
        })
    };

    onBudgetChange = (value) => {
        this.setState({
            budget: value
        });
    };

    render() {
        let escrow = this.state.escrow;
        let retailerItem = this.state.retailerItem;
        let brk = this.props.formProxy.currentBaseResource;

        let error = this.state.error ? (
            <p className='error-text-color'>
                <FormattedMessage id="errors.ESCROW_BALANCE_EXCEEDED"/>
            </p>
        ) : "";

        if (isNoU(brk.startDate) || isNoU(brk.endDate)) {
            return (
                <section>
                    <p>Set start and end dates for break before creating a budget for prizing.</p>
                    {error}
                </section>
            );
        }

        if (isNoU(escrow)) {
            return (
                <section>
                    <NumericInput value={this.state.budget} onValueChanged={this.onBudgetChange}/>
                    <Button onClick={this.onCreateBudgetClicked} loading={this.state.creatingBudget}>
                        Create Budget for Prizing
                    </Button>
                    {error}
                </section>
            )
        } else if (isNoU(retailerItem)) {
            return (
                <section>
                    <Button onClick={this.onStockEscrowButtonClicked} loading={this.state.creatingRetailerItem}>
                        Select Item
                    </Button>
                    <ReceiptItemModal isOpen={this.state.modifyingStock}
                                       onClose={this.onClose}
                                       lang={this.props.formProxy.currentBaseResource.lang}
                                       mode={RetailerItemFormModes.Create}
                                       retailerItem={this.state.newRetailerItem}
                                       deleteItem={this.deleteItem}
                                       onSubmit={this.createRetailerItem}
                                       onValueChanged={this.onValueChange}/>
                    {error}
                </section>
            )
        }

        let itemName = retailerItem.title || null;
        if (itemName) {
            itemName += " - ";
        } else {
            itemName = "";
        }

        return (
            <section>
                <p>Budget: {escrow.budget}</p>
                <p>Reward: {itemName}${retailerItem.price}</p>
                <p>Total Stock: {this.state.totalStock || 0}</p>
                <section>
                    <NumericInput value={this.state.totalItems} onValueChanged={this.onTotalItemsChanged}/>
                </section>
                <Button onClick={this.addStock} loading={this.state.stocking}>
                    {this.state.totalStock > 0 ? "Set" : "Add"} Stock
                </Button>
                {error}
            </section>
        )
    }
}

CampaignEscrowWidget.propTypes = {
    formProxy: PropTypes.instanceOf(ResourceFormProxy)
};

const mapState = (state) => {
    let writingResource = state.rewards.writingRetailerItemResource;
    return {
        imageId: writingResource.imageId
    }
};

const mapDispatch = (dispatch) => {
    console.log("CampaignEscrowWidget mapDispatch" );
    
    return {
        // TODO: Create api action to get campaign retailers
        // Are same as regular store right now, hardcoded to english store
        // will need to support different languages
        getRetailers: () => dispatch(requestRetailersAction(1)),
        setStoreAccount: () => dispatch(setStoreAccountAction({id: 1})),
        getNgcList: () => dispatch(requestNgcEndpointListAction()),
    }
};

export default connect(mapState, mapDispatch)(CampaignEscrowWidget);


// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/CampaignEscrowWidget.jsx